import React, { useEffect, useState, useRef } from "react";
import axios from 'axios'; 
import Swal from 'sweetalert2';
import { BASE_URL } from '../../App'
import { Backdrop, CircularProgress, Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import CRI from '../image/CRI-Logotrans.png'
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSearchParams } from 'react-router-dom';

const NewServiceClaimInvoice = () => {
    const [showTable, setShowTable] = useState(true);
    const [showTable1, setShowTable1] = useState(false);
    const [tokennumber, settokennumber] = useState('');
    const [open, setOpen] = React.useState(false);
    const [searchParams] = useSearchParams(); 
    const docNo = searchParams.get('docNo');  

    useEffect(() => {
        if (docNo) {
            fetchData(docNo);
        }
    }, []);
    
    const [formData, setFormData] = useState({
        fromAddress: "",
        claimedDate: "",
        invSerNo: "",
        gstNo: "",
        state: "",
        serviceType: "",
        scrNo: "",
        tollFreeNo: "",
        productSerialNo: "",
        customerName: "",
        productDescription: "",
        customerMobile: "",
        documentNo: "",
        documentDate: "",
        billNo: "",
        billDate: "",
        dealerName: "",
        serviceCenter: "",
        spareItems: [],
        labourItems: [],
        totalSpareAmount: "",
        totalLabourAmount: "",
        grandTotal: "",
    });

    const fetchData = async (docNo) => {
        setOpen(true);
        if(!docNo){
            setOpen(false);
            if (!docNo) {
                Swal.fire({
                    icon: "info",                 
                    text: "Please enter a document number!",
                });
                return;
            }
        }
        
        try {
            const response = await axios.post(BASE_URL + '/getduplicateinvoicecopy', { 
                tokenno: docNo 
            });
          
            const data = response.data;

            if (data && data.service_claim && data.service_claim.length > 0) {
                const serviceClaim = data.service_claim[0];
                const spares = data.spares_details.map(spare => ({
                    spareName: spare.spare_name,
                    hsnCode: spare.HSN_CODE,
                    quantity: parseFloat(spare.quantity),
                    rate: parseFloat(spare.rate),
                    totalAmount: parseFloat(spare.quantity)* parseFloat(spare.rate),
                }));

                const labourItems = data.labour_details.map(labour => ({
                    service: labour.labourcharge_description,
                    charge: parseFloat(labour.rate),
                    totalValue: parseFloat(labour.rate),
                }));

                const dealerAddress = data.dealer_details[0]?.NewFiled || "Not Available";

                setFormData(prevState => ({
                    ...prevState,
                    fromAddress: dealerAddress,
                    claimedDate: serviceClaim.createdon,
                    invSerNo: serviceClaim.serbill_no,
                    gstNo: data.cstnumber,
                    state: data.state,
                    serviceType: serviceClaim.servicetype,
                    scrNo: serviceClaim.servicecall_no,
                    tollFreeNo: serviceClaim.tokenno,
                    productSerialNo: serviceClaim.serial_no,
                    customerName: serviceClaim.name,
                    productDescription: serviceClaim.mat_code,
                    customerMobile: serviceClaim.phoneno,
                    documentNo: serviceClaim.doc_no,
                    documentDate: serviceClaim.createdon,
                    billNo: serviceClaim.serbill_no,
                    billDate: serviceClaim.billdate,
                    dealerName: data.partyname,
                    serviceCenter: serviceClaim.ascode,
                    spareItems: spares,
                    labourItems: labourItems,
                    totalSpareAmount: spares.reduce((total, item) => total + item.totalAmount, 0),
                    totalLabourAmount: labourItems.reduce((total, item) => total + item.totalValue, 0),
                    grandTotal: spares.reduce((total, item) => total + item.totalAmount, 0) + labourItems.reduce((total, item) => total + item.totalValue, 0),
                }));

                setOpen(false)
                setShowTable1(true);
            }
        } catch (error) {
            Swal.fire({
                icon: "info",                 
                text: "No Data Found !",
            });
            setOpen(false);
            console.error("Error fetching data:", error);
        }
    };

    const contentToPrintRef = useRef();

    const printPage = () => {
        const content = contentToPrintRef.current;
      
        const printWindow = window.open('', '', 'height=1000,width=800');
        printWindow.document.write('<html><head><title>Print</title>');
        printWindow.document.write('<style>');
        printWindow.document.write(`
          @page {
            size: A4;
            margin: 5mm;
          }
      
          body {
            font-family: Calibri, sans-serif;
            margin: 0;
            padding: 10px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
          }
      
          .print-wrapper {
            width: 100%;
            max-width: 800px;
            margin: 0 auto;
            border: 2px solid #000;
            padding: 15px;
            box-sizing: border-box;
          }
      
          .print-container {
            transform: scale(0.95);
            transform-origin: top center;
          }
      
          h3 {
            background-color: #0000CC;
            padding: 8px;
            color: white;
            font-family: Calibri, sans-serif;
            text-align: center;
            margin: 10px 0;
            font-size: 14px;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 5px 0;
            font-size: 12px;
          }
          
          td, th {
            padding: 4px;
            border: 1px solid #000;
          }
          
          .data-cell {
            border: 1px solid #000;
            padding: 4px;
            min-height: 20px;
          }
          
          .no-border {
            border: none !important;
          }
          
          .border-bottom {
            border-bottom: 1px solid #000 !important;
          }
          
          .border-top {
            border-top: 1px solid #000 !important;
          }
          
          .border-right {
            border-right: 1px solid #000 !important;
          }
          
          .border-left {
            border-left: 1px solid #000 !important;
          }
          
          .text-right {
            text-align: right;
          }
          
          .text-center {
            text-align: center;
          }
          
          .text-left {
            text-align: left;
          }
          
          .bold {
            font-weight: bold;
          }
          
          .red {
            color: #FF0000;
          }
          
          .blue-header {
            background-color: #0000CC;
            color: white;
            text-align: center;
            padding: 8px;
          }
          
          .checkbox-section {
            margin: 15px 0;
          }
          
          .notes {
            font-size: 11px;
            line-height: 1.2;
            margin: 10px 0;
          }
        `);
        printWindow.document.write('</style></head><body>');
        printWindow.document.write('<div class="print-wrapper">');
        printWindow.document.write('<div class="print-container">');
        printWindow.document.write(content.innerHTML);
        printWindow.document.write('</div>');
        printWindow.document.write('</div>');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
      
        // Wait for images to load before printing
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };
      
    const handleBack = () => {
        setShowTable(true);
        setShowTable1(false);
    };

    return (
        <div style={{ fontFamily: 'Calibri, sans-serif' }}>
            {showTable1 && ( 
                <>
                    <IconButton onClick={handleBack} style={{ marginBottom: "10px" }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <div> 
                        <div 
                            ref={contentToPrintRef}
                            style={{
                                fontFamily: "Calibri, sans-serif",
                                width: "800px",
                                margin: "0 auto",
                                padding: "15px",
                                border: "2px solid #000",
                                boxSizing: "border-box"
                            }}
                        >
                            {/* Header Section */}
                            <table style={{ width: "100%", border: "none", marginBottom: "15px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "30%", verticalAlign: "top", border: "none" }}>
                                            <div style={{ color: "#FF0000", fontWeight: "bold", marginBottom: "5px" }}>FROM</div>
                                            <div style={{ fontSize: "12px", lineHeight: "1.2" }}>{formData.fromAddress}</div>
                                        </td>
                                        <td style={{ width: "40%", border: "none" }}></td>
                                        <td style={{ width: "30%", textAlign: "right", border: "none", verticalAlign: "top" }}>
                                            <img src={CRI} alt="CRI" style={{ height: "60px", width: "180px" }} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3" style={{ textAlign: "right", border: "none", paddingTop: "10px" }}>
                                            <div style={{ fontWeight: "bold" }}>ESTIMATION / COST OF SERVICE</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Main Information Table */}
                            <table style={{ width: "100%", border: "1px solid #000", borderCollapse: "collapse", marginBottom: "15px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "10%", border: "1px solid #000", padding: "5px", verticalAlign: "top" }} rowSpan="7">
                                            <div style={{ fontWeight: "bold" }}>TO</div>
                                        </td>
                                        <td style={{ width: "45%", border: "1px solid #000", padding: "5px", textAlign: "right" }}>
                                            Claimed Date:&nbsp;&nbsp;
                                        </td>
                                        <td style={{ width: "45%", border: "1px solid #000", padding: "5px" }}>
                                            {formData.claimedDate}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>
                                            Invoice No. / Service No.:&nbsp;&nbsp;
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "5px" }}>
                                            {formData.invSerNo}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>
                                            GST No.:&nbsp;&nbsp;
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "5px" }}>
                                            {formData.gstNo}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>
                                            State:&nbsp;&nbsp;
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "5px" }}>
                                            {formData.state}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>
                                            Service Type:&nbsp;&nbsp;
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "5px" }}>
                                            {formData.serviceType}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", color: "#FF0000" }}>
                                            SCR No. / Service Call Report No.:&nbsp;&nbsp;
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "5px" }}>
                                            {formData.scrNo}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right", color: "#FF0000" }}>
                                            Toll Free / Service Call Token No.:&nbsp;&nbsp;
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "5px" }}>
                                            {formData.tollFreeNo}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Product and Customer Details */}
                            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "15px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "20%", padding: "3px", textAlign: "left", color: "#FF0000" }}>
                                            Product Serial No
                                        </td>
                                        <td style={{ width: "30%", border: "1px solid #000", padding: "3px" }}>
                                            {formData.productSerialNo}
                                        </td>
                                        <td style={{ width: "20%", padding: "3px", textAlign: "left" }}>
                                            Customer Name
                                        </td>
                                        <td style={{ width: "30%", border: "1px solid #000", padding: "3px" }}>
                                            {formData.customerName}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "3px", textAlign: "left" }}>
                                            Product Description
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "3px" }}>
                                            {formData.productDescription}
                                        </td>
                                        <td style={{ padding: "3px", textAlign: "left" }}>
                                            Customer Mobile No
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "3px" }}>
                                            {formData.customerMobile}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "3px", textAlign: "left" }}>
                                            Document No
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "3px" }}>
                                            {formData.documentNo}
                                        </td>
                                        <td style={{ padding: "3px", textAlign: "left" }}>
                                            Document Date
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "3px" }}>
                                            {formData.documentDate}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "3px", textAlign: "left" }}>
                                            Bill No
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "3px" }}>
                                            {formData.billNo}
                                        </td>
                                        <td style={{ padding: "3px", textAlign: "left" }}>
                                            Bill Date
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "3px" }}>
                                            {formData.billDate}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "3px", textAlign: "left" }}>
                                            Dealer Name
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "3px" }}>
                                            {formData.dealerName}
                                        </td>
                                        <td style={{ padding: "3px", textAlign: "left" }}>
                                            Service Center
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "3px" }}>
                                            {formData.serviceCenter}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Spare Items Table */}
                            <div style={{ backgroundColor: "#0000CC", color: "white", textAlign: "center", padding: "8px", margin: "10px 0" }}>
                                (A) DETAILS OF MATERIAL REPLACED ( SPARES & WINDING WIRE )
                            </div>
                            
                            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>SL_NO</th>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>Material Replaced</th>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>HSN Code</th>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>QTY</th>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>Price</th>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>Total Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.spareItems.length > 0 ? (
                                        formData.spareItems.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{index + 1}</td>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{item.spareName}</td>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{item.hsnCode}</td>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{item.quantity}</td>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{item.rate}</td>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{item.totalAmount}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>
                                                No spare items found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "15px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "85%", border: "1px solid #000", padding: "5px", textAlign: "right" }}>
                                            (A) Total Value( in Rs.)
                                        </td>
                                        <td style={{ width: "15%", border: "1px solid #000", padding: "5px", textAlign: "center" }}>
                                            {formData.totalSpareAmount}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Labour Items Table */}
                            <div style={{ backgroundColor: "#0000CC", color: "white", textAlign: "center", padding: "8px", margin: "10px 0" }}>
                                (B) LABOUR CHARGES \ OTHER CHARGES
                            </div>
                            
                            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>Slno</th>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>Services</th>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>Charges</th>
                                        <th style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>Total Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formData.labourItems.length > 0 ? (
                                        formData.labourItems.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{index + 1}</td>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{item.service}</td>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{item.charge}</td>
                                                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>{item.totalValue}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>
                                                No labour items found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "10px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "85%", border: "1px solid #000", padding: "5px", textAlign: "right" }}>
                                            (B) Total Value( in Rs.)
                                        </td>
                                        <td style={{ width: "15%", border: "1px solid #000", padding: "5px", textAlign: "center" }}>
                                            {formData.totalLabourAmount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ border: "1px solid #000", padding: "5px", textAlign: "right" }}>
                                            (A + B) Grand Total Value( in Rs.)
                                        </td>
                                        <td style={{ border: "1px solid #000", padding: "5px", textAlign: "center" }}>
                                            {formData.grandTotal}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Notes Section */}
                            <div style={{ margin: "15px 0" }}>
                                <div style={{ color: "red", marginBottom: "5px" }}>Note :</div>
                                <div style={{ fontSize: "12px", lineHeight: "1.2", marginBottom: "3px" }}>
                                    1. If GST is applicable, GST should be included in the Invoice.
                                </div>
                                <div style={{ fontSize: "12px", lineHeight: "1.2" }}>
                                    2. If non filing of Returns / GST is not paid else GST is not reflected in our GSTR-2B return,
                                    the GST amount will be debited to the respective service provider and will be collected.
                                </div>
                            </div>

                            {/* Checkbox Section */}
                            <div style={{ backgroundColor: "#00CCFF", color: "#FF0000", textAlign: "center", padding: "8px", borderBottom: "1px solid #000", margin: "15px 0" }}>
                                ENCLOSURE DETAILS ( Please ✓ appropriate Box )
                            </div>
                            
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>
                                    <tr style={{ textAlign: "center" }}>
                                        <td style={{ width: "25%", padding: "10px" }}>
                                            <input type="checkbox" disabled style={{ marginRight: "5px" }} />
                                            <span style={{ color: "#FF5050" }}>Warranty Coupon</span>
                                        </td>
                                        <td style={{ width: "25%", padding: "10px" }}>
                                            <input type="checkbox" disabled style={{ marginRight: "5px" }} />
                                            <span style={{ color: "#FF5050" }}>Winding Slip</span>
                                        </td>
                                        <td style={{ width: "25%", padding: "10px" }}>
                                            <input type="checkbox" disabled style={{ marginRight: "5px" }} />
                                            <span style={{ color: "#FF5050" }}>Customer Bill Copy</span>
                                        </td>
                                        <td style={{ width: "25%", padding: "10px" }}>
                                            <input type="checkbox" disabled style={{ marginRight: "5px" }} />
                                            <span style={{ color: "#FF5050" }}>Photo of the Pumpset with Newspaper of the day</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style={{ textAlign: "center", marginTop: "20px" }}> 
                            <Button 
                                size="small" 
                                variant="contained" 
                                onClick={printPage} 
                                endIcon={<PrintIcon />} 
                                style={{ fontFamily: 'Calibri, sans-serif' }}
                            >
                                <b>Print</b>
                            </Button>
                        </div>
                    </div>
                </>
            )}
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default NewServiceClaimInvoice;